!(function () {
    "use strict";
    var e = {
            5837: function (e, t, n) {
                n.d(t, {
                    PU: function () {
                        return u;
                    },
                    TS: function () {
                        return r;
                    },
                    Uy: function () {
                        return m;
                    },
                    Wj: function () {
                        return s;
                    },
                    hF: function () {
                        return y;
                    },
                    qn: function () {
                        return c;
                    },
                    sW: function () {
                        return d;
                    },
                });
                var o = n(4105);
                let i = document.getElementById("nav-wrapper"),
                    a = (e, t) => {
                        e.props.activeMenu = t;
                    };
                const r = (e) => {
                        let t;
                        if (
                            (e.classList.remove("nav--secondary-menu-open"),
                            (t = e.classList.contains("nav--mobile") ? e.querySelector(".nav--mobile__inner-container") : e.querySelector(".nav__secondary-menu")),
                            window.matchMedia("(max-width: 640px)").matches)
                        ) {
                            const n = e.querySelector(".nav__main-menu-link--active");
                            n && n.classList.remove("nav__main-menu-link--active"),
                                e.querySelector(".nav__main-menu-link--active") && e.querySelector(".nav__main-menu-link--active").classList.remove("nav__main-menu-link--active"),
                                e.querySelectorAll(".nav__secondary-menu__item--animate-in").forEach((e) => {
                                    e.classList.remove("nav__secondary-menu__item--animate-in"),
                                        window.setTimeout(() => {
                                            e.classList.remove("nav__secondary-menu__item--visible"), (t.height = "auto");
                                        }, 300);
                                });
                        }
                    },
                    s = (e) => {
                        (0, o.hO)(!1),
                            r(e),
                            a(e, 0),
                            i.removeAttribute("style"),
                            (i.props.navMargin = 0),
                            (i.props.submenuOpen = !1),
                            e.classList.remove("nav--open", "nav--secondary-menu-open", "animation-delay"),
                            document.querySelector(".overlay").classList.remove("open"),
                            document.querySelectorAll(".megamenu-opener, .menu-trigger").forEach((e) => {
                                e.classList.remove("active");
                            });
                    },
                    c = (e, t) => {
                        document.querySelectorAll(".megamenu-opener, .menu-trigger").forEach((e) => {
                            t !== e ? e.classList.remove("active") : t.classList.add("active");
                        }),
                            document.querySelectorAll(".nav").forEach((t) => {
                                t !== e && t.classList.contains("nav--open") && (t.classList.remove("nav--open", "animation-delay"), e.classList.add("animation-delay")),
                                    t.querySelectorAll("img").forEach((e) => {
                                        e.src = e.dataset.src;
                                    });
                            }),
                            (i.props.submenuOpen = !0),
                            (i.style.transition = "0.3s"),
                            (i.style.marginTop = 0),
                            e.classList.add("nav--open"),
                            document.querySelector(".overlay").classList.add("open");
                    },
                    l = (e, t) => {
                        e ? t.classList.add("nav__mobile-dropdown-wrapper--open") : t.classList.remove("nav__mobile-dropdown-wrapper--open");
                    },
                    d = (e) => {
                        e.querySelectorAll(".nav__mobile-dropdown-wrapper").forEach((e) => {
                            let t = e.querySelector(".nav__mobile-accordion-opener");
                            t &&
                                t.addEventListener("click", () => {
                                    t
                                        .closest(".nav--mobile__column")
                                        .querySelectorAll(".nav__mobile-dropdown-wrapper")
                                        .forEach((t) => {
                                            t !== e && t.classList.remove("nav__mobile-dropdown-wrapper--open");
                                        }),
                                        e.classList.contains("nav__mobile-dropdown-wrapper--open") ? l(!1, e) : l(!0, e),
                                        (t.closest(".nav--mobile__inner-container").style.height = t.closest(".nav__secondary-menu__item").offsetHeight + "px");
                                });
                        });
                    },
                    m = (e, t) => {
                        let n,
                            o = e.getAttribute("data-targetmenu"),
                            i = t.querySelector(`#${o}`);
                        (n = t.classList.contains("nav--mobile") ? t.querySelector(".nav--mobile__inner-container") : t.querySelector(".nav__secondary-menu")),
                            e.classList.contains("nav__main-menu-link--active") ||
                                (t.querySelectorAll(".nav__main-menu-link:not(.simple)").forEach((e, n) => {
                                    a(t, n);
                                }),
                                t.querySelectorAll(".nav__main-menu-link").forEach((e) => {
                                    e.classList.remove("nav__main-menu-link--active"), e.setAttribute("aria-expanded", !1);
                                }),
                                e.classList.add("nav__main-menu-link--active"),
                                e.setAttribute("aria-expanded", !0),
                                e.parentNode.querySelector(".nav__secondary-navigation-item-content") &&
                                    (window.innerHeight - 140 > e.parentNode.querySelector(".nav__secondary-navigation-item-content").offsetHeight
                                        ? (document.querySelector(".nav--mega_menu .nav__content").style.height = e.parentNode.querySelector(".nav__secondary-navigation-item-content").offsetHeight + 80 + "px")
                                        : (document.querySelector(".nav--mega_menu .nav__content").style.height = window.innerHeight - 140 + "px")),
                                t.querySelectorAll(".nav__secondary-menu__item").forEach((e) => {
                                    e.classList.remove("nav__secondary-menu__item--animate-in");
                                }),
                                i && i.classList.add("nav__secondary-menu__item--visible"),
                                setTimeout(() => {
                                    t.querySelectorAll(".nav__secondary-menu__item").forEach((e) => {
                                        e !== i
                                            ? (e.classList.remove("nav__secondary-menu__item--animate-in", "nav__secondary-menu__item--visible"), e.setAttribute("aria-hidden", "true"))
                                            : (e.classList.add("nav__secondary-menu__item--visible"),
                                              e.setAttribute("aria-hidden", "false"),
                                              requestAnimationFrame(() => {
                                                  e.classList.add("nav__secondary-menu__item--animate-in");
                                              }));
                                    });
                                }, 300));
                    },
                    u = (e) => {
                        let t = window.scrollY - e.props.lastScroll;
                        const n = document.getElementById("header-spacer");
                        if (((e.props.navMargin += t), e.props.navMargin >= e.offsetHeight)) {
                            e.classList.remove("header-visible");
                            const t = e.querySelectorAll("details.megamenu-open");
                            document.getElementById("overlay").classList.remove("open"),
                                t.forEach((e) => {
                                    e.classList.remove("active"), e.removeAttribute("open");
                                });
                        } else e.classList.add("header-visible");
                        e.props.submenuOpen ? (e.props.navMargin = 0) : (e.props.navMargin = Math.max(0, Math.min(e.props.navMargin, e.offsetHeight))), e.submenuOpen || (e.style.marginTop = -e.props.navMargin + "px");
                        const o = document.querySelector(".sticky-subheader"),
                            i = document.querySelector("#main-collection-filters");
                        console.log(o),
                            o &&
                                (console.log(o.getBoundingClientRect()),
                                0 === o.getBoundingClientRect().y
                                    ? ((e.props.transformAmount = -e.props.navMargin + e.offsetHeight),
                                      e.classList.add("sticky-active"),
                                      (o.style.marginTop = -0 + "px"),
                                      (o.style.paddingTop = 0 + "px"),
                                      o.classList.add("sticky--stuck"))
                                    : (o.classList.remove("sticky--stuck"), e.classList.remove("sticky-active"), i && (i.style.marginTop = 0))),
                            (e.props.lastScroll = Math.max(0, Math.min(window.scrollY, document.body.offsetHeight - window.innerHeight))),
                            0 === e.props.lastScroll ? (e.classList.add("reached-top"), (n.style.paddingTop = 0)) : (e.classList.remove("reached-top"), (n.style.paddingTop = 0 + "px"));
                    },
                    v = document.querySelectorAll(".predictive-search"),
                    p = document.getElementById("overlay"),
                    y = () => {
                        p.classList.remove("open"),
                            document.body.classList.remove("active", "search"),
                            v.forEach((e) => {
                                e.classList.remove("open"), (0, o.zx)(e.closest(".predictive-search-wrapper"));
                            });
                    };
            },
            4105: function (e, t, n) {
                n.d(t, {
                    gp: function () {
                        return r;
                    },
                    hO: function () {
                        return o;
                    },
                    zx: function () {
                        return c;
                    },
                });
                const o = function () {
                    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    const t = window.innerWidth - document.body.offsetWidth,
                        n = document.getElementById("nav-wrapper");
                    e
                        ? (document.body.classList.add("no-scroll"), (document.body.style.paddingRight = t + "px"), (n.style.paddingRight = t + "px"))
                        : (document.body.classList.remove("no-scroll"), (document.body.style.paddingRight = "0px"), (n.style.paddingRight = "0px"));
                };
                let i = () => {};
                const a = (e) => {
                        "Escape" === e.key && (i(), window.removeEventListener("keydown", a));
                    },
                    r = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (i = t), e && window.addEventListener("keydown", a), e || window.removeEventListener("keydown", a);
                    };
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        ((e) => {
                            Math.easeInOutQuad = function (e, t, n, o) {
                                return (e /= o / 2) < 1 ? (n / 2) * e * e + t : (-n / 2) * (--e * (e - 2) - 1) + t;
                            };
                            const t = document.getElementById("grid-archive-header"),
                                n = document.getElementById("nav-wrapper");
                            let o = 0,
                                i = 0;
                            t && (o = t.offsetHeight + 50), n && (i = n.offsetHeight + 50);
                            const a = e.offsetTop - o - i,
                                r = window.scrollY,
                                s = a - r;
                            let c = 0;
                            const l = () => {
                                c += 5;
                                const e = Math.easeInOutQuad(c, r, s, 200);
                                window.scrollTo(0, e), c < 200 && setTimeout(l, 5);
                            };
                            l();
                        })(document.querySelector(t));
                    });
                });
                const s = {};
                function c(e) {
                    document.removeEventListener("focusin", s.focusin), document.removeEventListener("focusout", s.focusout), document.removeEventListener("keydown", s.keydown), e && e.focus();
                }
            },
        },
        t = {};
    function n(o) {
        var i = t[o];
        if (void 0 !== i) return i.exports;
        var a = (t[o] = { exports: {} });
        return e[o](a, a.exports, n), a.exports;
    }
    (n.d = function (e, t) {
        for (var o in t) n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, { enumerable: !0, get: t[o] });
    }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (function () {
            var e = n(5837),
                t = n(4105),
                o = void 0 !== window.safari,
                i = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
            let a = document.getElementById("nav-wrapper");
            (a.props = {}), (a.props.navMargin = 0), (a.props.transformAmount = 0), (a.props.lastScroll = window.scrollY), (a.props.submenuOpen = !1), (a.props.activeMenu = 0);
            const r = function () {
                const n = document.getElementById("overlay");
                if ("click" == document.querySelector(".header").getAttribute("data-ux")) {
                    a.querySelectorAll(".nav__content details > summary").forEach((e) => {
                        e.addEventListener("click", (e) => {
                            e.preventDefault();
                        });
                    });
                    const r = a.querySelectorAll("details.megamenu-open > summary");
                    r.forEach((c) => {
                        const l = () => {
                            c.parentNode.classList.remove("active"),
                                c.parentNode.removeAttribute("open"),
                                window.setTimeout(() => {
                                    n.classList.remove("open", "overlay--mid");
                                }, 2);
                        };
                        function d(e) {
                            let t = window.matchMedia("(min-width: 1024px)");
                            e.target.closest(".main-nav-item") ||
                                e.target.parentNode.classList.contains("main-nav-item") ||
                                e.target.parentNode.hasAttribute("open") ||
                                e.target.classList.contains("search-trigger") ||
                                e.target.classList.contains("search-icon") ||
                                e.target.classList.contains("icon") ||
                                !t.matches ||
                                (window.setTimeout(() => {
                                    n.classList.remove("open", "overlay--mid");
                                }, 2),
                                c.parentNode.removeAttribute("open"),
                                a.removeEventListener("click", d, !1),
                                a.removeEventListener("mouseover", d, !1),
                                n.removeEventListener("mouseover", d, !1));
                        }
                        c.addEventListener("click", (m) => {
                            (0, e.hF)(),
                                (0, t.gp)(!0, l),
                                window.setTimeout(() => {
                                    n.classList.add("open", "overlay--mid"), (o || i) && s(c);
                                }, 1),
                                a.addEventListener("click", d, !1),
                                n.addEventListener("click", d, !1),
                                r.forEach((e) => {
                                    e !== c && (e.classList.remove("active"), e.parentNode.removeAttribute("open"));
                                }),
                                c.parentNode.hasAttribute("open") &&
                                    window.setTimeout(() => {
                                        n.classList.remove("open", "overlay--mid");
                                    }, 2),
                                n.addEventListener("click", () => {
                                    window.setTimeout(() => {
                                        n.classList.remove("open", "overlay--mid");
                                    }, 2),
                                        c.parentNode.removeAttribute("open");
                                });
                        });
                    });
                } else
                    a.querySelectorAll("details.megamenu-open").forEach((t) => {
                        (t.onmouseover = function () {
                            (0, e.hF)(),
                                this.classList.add("active"),
                                this.setAttribute("open", "true"),
                                window.setTimeout(() => {
                                    n.classList.add("open", "overlay--mid"), (o || i) && s(t);
                                }, 1);
                        }),
                            (t.onmouseout = function () {
                                this.classList.remove("active"),
                                    this.removeAttribute("open"),
                                    window.setTimeout(() => {
                                        n.classList.remove("open", "overlay--mid");
                                    }, 2);
                            });
                    }),
                        a.querySelectorAll("details > summary").forEach((e) => {
                            e.addEventListener("click", (e) => {
                                //e.preventDefault();
                            });
                        });
                a.querySelectorAll(".nav__main-menu--multi_level_megamenu details").forEach((e) => {
                    e.setAttribute("open", "true");
                }),
                    document.querySelectorAll(".nav").forEach((t) => {
                        (0, e.TS)(t);
                    }),
                    document.querySelectorAll(".nav").forEach((t) => {
                        (t.props = {}),
                            t.querySelectorAll(".nav__main-menu-link").forEach((n, o) => {
                                0 == o &&
                                    n.parentNode.querySelector(".nav__secondary-navigation-item-content") &&
                                    (window.innerHeight - 140 > n.parentNode.querySelector(".nav__secondary-navigation-item-content").offsetHeight
                                        ? (document.querySelector(".nav--multilevel .nav__content").style.height = n.parentNode.querySelector(".nav__secondary-navigation-item-content").offsetHeight + 160 + "px")
                                        : (document.querySelector(".nav--multilevel .nav__content").style.height = window.innerHeight - 140 + "px")),
                                    window.matchMedia("(hover: hover)").matches &&
                                        window.matchMedia("(min-width: 1024px)").matches &&
                                        n.addEventListener("mouseover", () => {
                                            (0, e.Uy)(n, t);
                                        }),
                                    n.addEventListener("focus", () => {
                                        (0, e.Uy)(n, t);
                                    }),
                                    n.addEventListener("click", () => {
                                        t.classList.add("nav--secondary-menu-open"), (0, e.Uy)(n, t);
                                        let o = n.getAttribute("data-targetmenu"),
                                            i = t.querySelector(`#${o}`),
                                            a = t.querySelector(".nav--mobile__inner-container");
                                        t.classList.contains("nav--mobile") && ((t.querySelector(".container").scrollTop = 0), i.offsetHeight > 0 && (a.style.height = i.offsetHeight + "px"));
                                    });
                            }),
                            t.querySelectorAll(".nav__secondary-menu__close").forEach((n) => {
                                n.addEventListener("click", () => {
                                    (0, e.TS)(t), t.classList.contains("nav--mobile") && (t.querySelector(".nav--mobile__inner-container").style.height = "auto");
                                });
                            }),
                            t.querySelectorAll(".nav__mobile-close").forEach((n) => {
                                n.addEventListener("click", () => {
                                    (0, e.Wj)(t);
                                });
                            }),
                            (0, e.sW)(t, !0);
                    });
            };
            r(),
                Shopify.designMode
                    ? document.getElementById("nav-wrapper").classList.add("header-visible", "reached-top")
                    : (window.addEventListener("scroll", () => {
                          (0, e.PU)(a);
                      }),
                      (0, e.PU)(a));
            const s = (e) => {
                    const t = e.nextSibling,
                        n = t.parentNode.getBoundingClientRect().left,
                        o = (a.querySelector(".header > .container").getBoundingClientRect().left, t.getBoundingClientRect().width),
                        i = t.closest(".container").getBoundingClientRect().width;
                    let r = 0;
                    if (n + o <= i) t.style.left = 0;
                    else {
                        var s = i - (n + o + 16);
                        (t.style.left = s + "px"),
                            t.getBoundingClientRect().left < t.closest(".container").getBoundingClientRect().left && ((s += t.closest(".container").getBoundingClientRect().left - t.getBoundingClientRect().left), (t.style.left = s + "px")),
                            (r -= s),
                            t.querySelector(".nav__tip") && (t.querySelector(".nav__tip").style.left = r + "px");
                    }
                },
                c = () => {
                    let n = document.querySelector(".menu-trigger"),
                        o = document.querySelector(".nav--mobile");
                    n &&
                        n.addEventListener("click", (i) => {
                            i.stopImmediatePropagation(), n.classList.contains("active") ? (0, e.Wj)(o) : ((0, e.qn)(o, n), (0, t.hO)(!0));
                        });
                };
            c();
            const l = () => {
                let t = window.matchMedia("(max-width: 1024px)");
                t.addEventListener("change", () => {
                    document.querySelectorAll(".nav").forEach((t) => {
                        (0, e.Wj)(t);
                    }),
                        t.matches && ((a.style.marginTop = 0), (a.props.navMargin = 0));
                });
            };
            l();
            const d = () => {
                a.querySelectorAll(".nav:not(.nav--mobile)").forEach((e) => {
                    const t = e.parentNode.getBoundingClientRect().left,
                        n = a.querySelector(".header > .container").getBoundingClientRect().left,
                        o = e.getBoundingClientRect().width,
                        i = e.closest(".container").getBoundingClientRect().width;
                    let r = 0;
                    const s = t + o <= i;
                    if (
                        (e.querySelector(".nav__tip") &&
                            ((e.querySelector(".nav__tip").style.left = 0),
                            (r = e.parentNode.classList.contains("multi_level_megamenu") ? t - n + e.parentNode.offsetWidth / 2 - 16 : e.parentNode.offsetWidth / 2),
                            (e.querySelector(".nav__tip").style.left = r + "px")),
                        e.parentNode.classList.contains("multi_level_megamenu"))
                    )
                        e.style.left = -t + n + "px";
                    else if (s) e.style.left = 0;
                    else {
                        var c = i - (t + o + 16);
                        (e.style.left = c + "px"),
                            e.getBoundingClientRect().left < e.closest(".container").getBoundingClientRect().left && ((c += e.closest(".container").getBoundingClientRect().left - e.getBoundingClientRect().left), (e.style.left = c + "px")),
                            (r -= c),
                            e.querySelector(".nav__tip") && (e.querySelector(".nav__tip").style.left = r + "px");
                    }
                });
            };
            window.addEventListener("load", function () {
                d();
            }),
                window.addEventListener("resize", () => {
                    window.matchMedia("(min-width: 1024px)").matches && d();
                }),
                Shopify.designMode &&
                    document.addEventListener("shopify:section:load", () => {
                        r(), d(), c(), l();
                    });
        })();
})();
